<template>
  <div>
    <span>tick: {{ tick }}</span>
    <span> tick duration: {{ tickDuration }}ms</span>
    <span v-if="tickDuration"> tick freq: {{ tickFrequency }}Hz</span>
    <span v-if="realTickDuration">
      real tick freq: {{ realTickFrequency }}Hz</span
    >
  </div>
  <div v-if="stateComputeDuration">
    <span>New state computed in {{ stateComputeDuration }}ms</span>
  </div>
</template>

<script>
export default {
  props: {
    tick: { type: Number, required: true },
    tickDuration: { type: Number, required: true },
    realTickDuration: { type: Number, required: true },
    stateComputeDuration: { type: Number },
  },
  computed: {
    tickFrequency() {
      return (1000 / this.tickDuration).toFixed(1);
    },
    realTickFrequency() {
      return (1000 / this.realTickDuration).toFixed(1);
    },
  },
};
</script>

<style></style>
